import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import axios from "axios";

import VueCurrencyInput from "vue-currency-input";
import './registerServiceWorker'

Vue.config.productionTip = false;
Vue.prototype.$http = axios;

Vue.use(VueCurrencyInput);

Vue.filter("currencyFormat", function(value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat("NGN", {
    // minimumFractionDigits: 0,
    style: "currency",
    currency: "NGN",
  });
  return formatter.format(value);
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
